// extracted by mini-css-extract-plugin
export default {"container":"_31GES","header":"_1qAhD","link":"_37R5k","list":"drQ9s"};